const ANONYMOUS_ID = 'ajs_anonymous_id';

export { ANONYMOUS_ID };
